module.exports = __webpack_public_path__ + "224b48d2cd86d9ac79b57296d9d14fd3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/admin.png
// module id = 206
// module chunks = 0